export const NOTIFY_LTN_USERID = 368462224434;
